// ============================================================================
// JARVISTRAVEL - START PLANNING CARD
// A friendly, on-brand "nothing here yet → let's fix that" state, so views that
// need a trip never look dead for a new user. The CTA opens the Jarvis planner.
// ============================================================================

import { type LucideIcon } from 'lucide-react';
import { LogoIcon } from '@/app/components/shared/Logo';

interface StartPlanningCardProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  ctaLabel?: string;
  onCta?: () => void;
  className?: string;
}

export function StartPlanningCard({ icon: Icon, title, subtitle, ctaLabel = 'Plan a trip with Jarvis', onCta, className = '' }: StartPlanningCardProps) {
  return (
    <div className={`flex flex-col items-center text-center py-14 px-6 ${className}`}>
      <div className="relative mb-5">
        <div className="absolute inset-0 rounded-3xl bg-accent/20 blur-xl" />
        <div className="relative w-16 h-16 rounded-3xl bg-surface-raised border border-border flex items-center justify-center text-accent">
          <Icon className="w-8 h-8" strokeWidth={1.5} />
        </div>
      </div>
      <h3 className="text-lg font-bold text-ink">{title}</h3>
      <p className="text-sm text-muted mt-1.5 max-w-xs">{subtitle}</p>
      {onCta && (
        <button
          onClick={onCta}
          className="mt-5 inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-brand text-brand-fg font-semibold active:scale-95 transition-transform"
        >
          <LogoIcon className="w-5 h-5" title={null} /> {ctaLabel}
        </button>
      )}
    </div>
  );
}

export default StartPlanningCard;
